<template>
  <div class="save-up-settle-in">
    <h1>Save Up & Settle In Account</h1>
    <b-img fluid src="/images/save-up-settle-in-poster.png" alt="Save Up Settle In"
           class="d-block mx-auto p-0 rounded-xl float-md-right ml-md-3 col-12 col-sm-8 col-md-5 mb-4"
    />
    <ul>
      <li>Want to build your financial resilience?</li>
      <li>Keen to kickstart a savings habit?</li>
      <li>Fancy getting £25 just for saving money?</li>
    </ul>
    <p>
      Then you’re in the right place!
    </p>
    <p>
      The Save Up & Settle In scheme is designed for individuals living in temporary accommodation in Tameside or Glossop. It aims to support long-term financial wellbeing by encouraging regular saving through a local credit union.
    </p>
    <p>
      Start small, save regularly, and set yourself up for success when moving into permanent accommodation. Having a savings pot can help with essentials like flooring, furniture, or appliances.
    </p>

    <h4>How it works:</h4>
    <ul>
      <li>Open an account with a participating credit union.</li>
      <li>Save a minimum £25, by making regular payments into your SUSI Account during the first three months.</li>
      <li>The first 40 savers to hit that milestone, will receive a £25 top-up as a reward.</li>
    </ul>

    <h4>Keep Saving</h4>
    <p>
      Didn’t miss the money when saving? Increase it to £20/month or £5 a week and after just one year you’ll have around £250 in savings! That’s enough for a fridge freezer or a contribution toward new flooring.
    </p>

    <h4>Eligibility:</h4>
    <p>
      To qualify, you must:
    </p>
    <ul>
      <li>Be 18 or over</li>
      <li>Live in Tameside or Glossop</li>
      <li>Be in temporary accommodation provided by a social housing provider, local authority, or other social landlord</li>
    </ul>
    <p>
      Read the <a href="/docs/save-up-settle-in-t-and-c-cashbox-2025-07.pdf" target="_blank">full terms and conditions here</a>
    </p>


    <div class="d-flex flex-column flex-md-row mb-3" style="gap:0.5rem;">
      <a href="https://cashbox.cuaccount.com/login/" target="_blank" class="btn btn-primary">Existing Members - Apply Here</a>
      <a href="https://cashbox.cuaccount.com/join/" target="_blank" class="btn btn-success">New Members</a>
    </div>

    <p>What other benefits does the Cash Box Credit Union have?</p>
    <ul>
      <li>We treat our members like family, ensuring that every request receives the care and attention it deserves</li>
      <li>All loan applications are reviewed on an individual basis rather than relying solely on automated decisions</li>
      <li>The interest rate is fixed for the term of the loan</li>
      <li>No setup or early repayment fees</li>
      <li>Free Loan Protection Cover up to £1500</li>
      <li>Save as you borrow - each payment you make adds a little more to your savings</li>
    </ul>

    <p>
      If you need more information on our Credit Union Loan Products, please contact
      our friendly staff on 0161 342 3266 or by emailing
      <a href="mailto:enquiries@cashbox.org.uk">enquiries@cashbox.org.uk</a>.
    </p>

    <hr />
    <p>
      Credit Unions are financial community co-operatives that promote savings as
      well as loans.
    </p>
    <p>
      Credit Union members pool their savings to provide the funds from which loans
      are made. The interest on loans pays for the running of the credit union and
      if there is a surplus, members get a share of the profit known as a dividend.
    </p>
    <p>
      We expect all of our members to save as much as they can afford, even if they
      are repaying a loan. As a minimum, we would expect you to save at least £2 per
      week/£10 per month and keep this in your savings account while you have a
      loan outstanding with us. Once your savings balance is higher than your loan
      balance, you may if you wish withdraw the difference.
    </p>
  </div>
</template>

<script>
import loanProducts from "@/data/loan-products";

export default {
  name: 'ReserveLoan',
  metaInfo() {
    return {
      title: 'Credit Union Save Up Settle In | Cash Box Credit Union',
      meta: [
        { name: 'keywords', content: "Credit, Union, Reserve, Loan" },
        { name: 'description', content: "Save Up Settle In aims to support long-term financial wellbeing by encouraging regular saving through a local credit union." }
      ],
    };
  },
  computed: {
    calculator() {
      return loanProducts.find(product => product.id === 'reserve');
    },
    borrowUpTo() {
      return this.calculator.amount.max.toLocaleString('en-GB', {
        style: 'currency',
        currency: 'GBP',
        maximumFractionDigits: 0,
      });
    },
    startingRate() {
      let rates =  this.calculator.rates;
      rates = rates.sort((a, b) => a.display - b.display);
      return `${rates[0].display}%`;
    },
    maxYears() {
      return this.calculator.period.max / 12;
    }
  }
}
</script>

<style scoped>

</style>
